import "core-js/modules/es.array.index-of";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "C:/projects/michelin-hp/node_modules/@babel/runtime/helpers/asyncToGenerator";
import { axiosInstance } from 'boot/axios';

var parseUrl = function parseUrl(state, id) {
  if (state.relationModel && id) {
    return state.model + '/' + id + '/' + state.relationModel;
  } else {
    return id ? state.model + '/' + id : state.model;
  }
};
/**
 * Cleans the internal attributes
 * of th given model
 * The internal attributes must have at least one $ symbol
 * @param {*} model
 */


var _clean = function _clean(model) {
  var cleaned = {};

  for (var key in model) {
    if (key.indexOf('$') < 0) cleaned[key] = model[key];
  }

  return cleaned;
};

export function get(_x, _x2) {
  return _get.apply(this, arguments);
}

function _get() {
  _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, payload) {
    var commit,
        state,
        forceUpdate,
        id,
        response,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, state = _ref.state;
            forceUpdate = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
            id = payload.id;
            delete payload.id;

            if (!(state.item && id === state.item.id && !forceUpdate)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", state.item);

          case 6:
            _context.prev = 6;
            _context.next = 9;
            return axiosInstance.get(parseUrl(state, id), {
              params: payload
            });

          case 9:
            response = _context.sent;
            commit('item', response.data);
            return _context.abrupt("return", response.data);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](6);
            throw new Error(_context.t0.message);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 14]]);
  }));
  return _get.apply(this, arguments);
}

export function query(_ref2, payload) {
  var commit = _ref2.commit,
      state = _ref2.state;
  var options = {
    params: payload
  };
  return axiosInstance.get(parseUrl(state), options).then(function (response) {
    commit('items', response.data.items);
    commit('pagination', response.data.pagination);
  });
}
/**
 *  Saves a file item
 * @param {Object} ctx The current context object
 * @param {Object} params The resource params data
 */

export function save(_x3, _x4) {
  return _save.apply(this, arguments);
}
/**
 *  Deletes a file item
 * @param {Object} ctx The current context object
 * @param {Object} model The model data
 */

function _save() {
  _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ctx, params) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return axiosInstance.post('items', _clean(params));

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _context2.t0);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _save.apply(this, arguments);
}

export function remove(_x5, _x6) {
  return _remove.apply(this, arguments);
}

function _remove() {
  _remove = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(ctx, id) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return axiosInstance.delete("items/".concat(id));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _context3.t0);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _remove.apply(this, arguments);
}

export function update(_ref3, payload) {
  var state = _ref3.state;
  return axiosInstance.post(parseUrl(state, payload.id), payload);
}